import { Layout } from '../../components/layout/Layout';
import ProveedoresCRUD from '../../components/config/ProveedoresCRUD';
import { usePermissions } from '../../hooks/usePermissions';
import { Truck } from 'lucide-react';

const ProveedoresPage = () => {
  const { canCreate, canUpdate, canDelete } = usePermissions('config', 'proveedores');

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="page-header">
          <div className="flex items-center gap-3">
            <Truck className="h-8 w-8 text-primary" strokeWidth={1.5} />
            <div>
              <h1 className="page-title">Proveedores</h1>
              <p className="page-subtitle">Administracion de proveedores y vendors</p>
            </div>
          </div>
        </div>

        {/* CRUD Component */}
        <ProveedoresCRUD
          canCreate={canCreate}
          canUpdate={canUpdate}
          canDelete={canDelete}
        />
      </div>
    </Layout>
  );
};

export default ProveedoresPage;
